const padTwoDigits = (value: number): string => String(value).padStart(2, '0');

/**
 * Formats the seconds left on a countdown. The layout is chosen from
 * `initialSeconds`, so the timer keeps its width while it counts down:
 * under 10 minutes `m:ss`, under an hour `mm:ss`, under 10 hours `h:mm:ss`,
 * otherwise `hh:mm:ss` (hours do not wrap at a day). Negative values show as zero.
 *
 * @param initialSeconds - the value the countdown started from, `seconds` by default
 *
 * @example
 * formatCountdown(59); // '0:59'
 * formatCountdown(5, 600); // '00:05'
 * formatCountdown(3725); // '1:02:05'
 */
export function formatCountdown(
  seconds: number,
  initialSeconds: number = seconds,
): string {
  const total = Math.max(0, seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = padTwoDigits(total % 60);

  if (initialSeconds < 600) {
    return `${minutes}:${rest}`;
  }

  if (initialSeconds < 3600) {
    return `${padTwoDigits(minutes)}:${rest}`;
  }

  if (initialSeconds < 36000) {
    return `${hours}:${padTwoDigits(minutes)}:${rest}`;
  }

  return `${padTwoDigits(hours)}:${padTwoDigits(minutes)}:${rest}`;
}
